import $ from 'jquery'
import manager from '../manager'
import {activeAllLazyImageDom} from '@/view/lib/lazy'

manager.add('goodsCarousel', {
	created(per) {
		activeAllLazyImageDom(this.dom)
		var total=$(this.dom).find("li").not(".virtual").length
		if(total<per){
			$(this.dom).find(".arrow-right").hide()
			$(this.dom).find(".arrow-left").hide()
			return
		}
		this.pagenum=total+1
		this.box=$(this.dom).find("ul")
		for(let i=0;i<per-1;i++){
			this.box.append($(this.dom).find("li").not(".virtual").clone().addClass("virtual"))
		}
		this.box.append($(this.dom).find("li").slice(0,per).clone().addClass("virtual"))
		manager.active($(this.dom).find("ul")[0])
		this.index=0
        $(this.dom).find(".arrow-right").on("click",()=>{
			this.index++
			this.switch()
        })
		$(this.dom).find(".arrow-left").on("click",()=>{
			this.index--
			this.switch()
		})
	},
	async switch(){
		if(this.index<0){
			this.index=this.pagenum-1
			this.box.css({"transform":`translateX(${-100*this.index}%)`,"transition":"none"})
			this.index--
		}else if(this.index>this.pagenum-1){
			this.index=0
			this.box.css({"transform":`translateX(${-100*this.index}%)`,"transition":"none"})
			this.index++
		}
		setTimeout(()=>{
			this.box.css({"transform":`translateX(${-100*(this.index)}%)`,"transition":""})
		},1)
	},
	destroyed() {
		$(this.dom).find(".virtual").remove()
        $(this.dom).find(".arrow-right").off()
        $(this.dom).find(".arrow-left").off()
	}
})
